var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoWishlist(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 156.78,
    height: 172.8,
    viewBox: "0 0 156.78 172.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3863",
    "data-name": "Group 3863",
    transform: "translate(-1135.213 -607.685)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_9477",
    "data-name": "Rectangle 9477",
    transform: "translate(1217.711 667.322) rotate(20)",
    fill: "#fff",
    stroke: "#343434",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 79.049,
    height: 91.653,
    rx: 16,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 76.049,
    height: 88.653,
    rx: 14.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9478",
    "data-name": "Rectangle 9478",
    width: 58.257,
    height: 67.546,
    rx: 16,
    transform: "translate(1223.358 680.818) rotate(20)",
    fill: "#e8e8e8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3861",
    "data-name": "Group 3861",
    transform: "translate(-6 -11.376)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9456",
    "data-name": "Rectangle 9456",
    width: 89.33,
    height: 101.406,
    rx: 16,
    transform: "translate(1141.213 639.293)",
    fill: "#e8e8e8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_9450",
    "data-name": "Rectangle 9450",
    transform: "translate(1149.036 649.514)",
    fill: "#fff",
    stroke: "#343434",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 89.33,
    height: 109.843,
    rx: 16,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 86.33,
    height: 106.843,
    rx: 14.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9452",
    "data-name": "Rectangle 9452",
    width: 35.553,
    height: 11.851,
    rx: 5.925,
    transform: "translate(1164.074 720.506)",
    fill: "rgba(0,0,0,0.09)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9476",
    "data-name": "Rectangle 9476",
    width: 59,
    height: 50,
    rx: 7,
    transform: "translate(1164 662)",
    fill: "#e8e8e8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Iconly_Bold_Heart",
    "data-name": "Iconly/Bold/Heart",
    transform: "translate(1202.937 619.94)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Heart",
    transform: "translate(2 2.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5198",
    "data-name": "Path 5198",
    d: "M12.6,0a12.524,12.524,0,0,1,3.674.662h.118a.7.7,0,0,1,.181.118,7.073,7.073,0,0,1,1.264.524h0l.762.341c.3.161.662.459.863.582a6.1,6.1,0,0,1,.6.379A12.568,12.568,0,0,1,27.787,0a11.721,11.721,0,0,1,3.732.582c7.405,2.408,10.074,10.533,7.845,17.635a25.536,25.536,0,0,1-6.037,9.648,77.154,77.154,0,0,1-12.7,9.951h0l-.5.3L19.6,37.8A76.427,76.427,0,0,1,6.823,27.846,25.947,25.947,0,0,1,.782,18.218c-2.267-7.1.4-15.228,7.887-17.677A9.067,9.067,0,0,1,10.453.121h.241A11.633,11.633,0,0,1,12.379,0H12.6Z",
    transform: "translate(0 0)",
    fill: "#ff091b",
    stroke: "#343434",
    strokeLinejoin: "round",
    strokeWidth: 3
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Iconly_Light-Outline_Heart",
    "data-name": "Iconly/Light-Outline/Heart",
    transform: "translate(1201.292 617.055)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Heart-2",
    "data-name": "Heart",
    transform: "translate(2 3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    d: "M30.713,7.937a7.484,7.484,0,0,1,5.169,6.528,1.592,1.592,0,0,1-1.458,1.715c-.045,0-.087.006-.132.006a1.592,1.592,0,0,1-1.586-1.463,4.3,4.3,0,0,0-2.97-3.755,1.592,1.592,0,1,1,.976-3.031Z",
    transform: "translate(0 0)",
    fill: "#fff",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3862",
    "data-name": "Group 3862"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5167",
    "data-name": "Path 5167",
    d: "M2837.58-15100.612l-1.806,9.027",
    transform: "translate(-4422.341 14891.833) rotate(11)",
    fill: "none",
    stroke: "#e8e8e8",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5169",
    "data-name": "Path 5169",
    d: "M2837.58-15100.612l-1.806,9.027",
    transform: "matrix(0.485, 0.875, -0.875, 0.485, -13324.068, 5464.563)",
    fill: "none",
    stroke: "#e8e8e8",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5168",
    "data-name": "Path 5168",
    d: "M2837.58-15100.612l-1.806,9.027",
    transform: "translate(-10099.577 10968.142) rotate(37)",
    fill: "none",
    stroke: "#e8e8e8",
    strokeLinecap: "round",
    strokeWidth: 3
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoWishlist);
export default __webpack_public_path__ + "static/media/no_wishlist.999f5865e75e8165a533b5ea94390966.svg";
export { ForwardRef as ReactComponent };